var App = App || {};

App.WidgetTestimonials = (function ($) {
    'use strict';

    function Init(widget) {
        Carousel(widget);
        VideoModal(widget);
    }

    function Animate(widget) {
        const animate = widget.find(".widget-testimonials__carousel");
        animate.ZagScrollAnimate({
            targets: [
                { selector: ".splide__slide", type: "animate__fadeInUp", stagger: 200 }
            ]
        });
    }

    function Carousel(widget) {

        const carousel = widget.find(".splide");

        if (carousel.length) {

            const options = {
                type: 'slide',
                rewind: true,
                speed: 500,
                arrows: true,
                pagination: false,
                autoWidth: true
            }

            const splide = new Splide(carousel[0], options);

            splide.on('overflow', function (isOverflow) {
                splide.go(0);

                splide.options = {
                    arrows: isOverflow,
                    drag: isOverflow,
                    clones: isOverflow ? undefined : 0,
                    label: "Testimonials Carousel"
                };

                carousel.toggleClass("is-carousel", isOverflow);
            });

            splide.on('mounted', function () { Animate(widget); });
            splide.mount();
        }
    }

    function VideoModal(widget) {

        const videoModalIds = widget.siblings(".modal").toArray().filter(modal => {
            const widgetId = widget[0].id;
            return modal.id.startsWith(`${widgetId}_Video`);
        });

        videoModalIds.forEach(function (videoModal) {
            const video = $(videoModal).find(".partial-video");
            const modal = video.parents(".modal");
            modal
                .on("shown.bs.modal", function () {
                    App.SharedVideo.Play(video)
                }).on("hide.bs.modal", function () {
                    App.SharedVideo.Stop(video)
                });
        });
    }

    return {
        Init: Init
    };

})(jQuery);